import { motion } from "framer-motion";

/**
 * Animated, theme-aware MCP mockup: an AI agent conversation where the assistant
 * calls onBookmarks tools (create_bookmark) and a saved bookmark materializes.
 * Sells the "let your AI talk to your bookmarks" story without a screenshot.
 */

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.16, delayChildren: 0.2 } },
};
const item = {
  hidden: { opacity: 0, y: 10 },
  show: { opacity: 1, y: 0, transition: { duration: 0.4, ease: "easeOut" } },
};

export const McpMock = ({ className = "" }) => {
  return (
    <motion.div
      className={`obm-mock obm-mock--mcp ${className}`}
      variants={container}
      initial={false}
      animate="show"
    >
      <div className="obm-mock__chrome">
        <span className="obm-mock__dot" style={{ background: "#ef4444" }} />
        <span className="obm-mock__dot" style={{ background: "#f59e0b" }} />
        <span className="obm-mock__dot" style={{ background: "#10b981" }} />
        <div className="obm-mock__omnibox">
          <i className="bi bi-robot me-1" />
          AI agent · onBookmarks MCP
        </div>
      </div>

      <div className="obm-mock__body obm-mock__chat">
        <motion.div
          className="obm-mock__msg obm-mock__msg--user"
          variants={item}
        >
          Save this article and tag it “ai”
        </motion.div>

        <motion.div className="obm-mock__tool" variants={item}>
          <i className="bi bi-tools" />
          <code>create_bookmark</code>
          <span className="obm-mock__tool-ok">
            <i className="bi bi-check-lg" /> called
          </span>
        </motion.div>

        <motion.div className="obm-mock__card" variants={item}>
          <span
            className="obm-mock__fav"
            style={{ background: "var(--bs-primary)" }}
          >
            A
          </span>
          <span className="obm-mock__meta">
            <span className="obm-mock__title">
              Building agents with the Model Context Protocol
            </span>
            <span className="obm-mock__domain">anthropic.com</span>
          </span>
          <span className="obm-mock__tag">ai</span>
        </motion.div>

        <motion.div
          className="obm-mock__msg obm-mock__msg--agent"
          variants={item}
        >
          <i className="bi bi-check-circle-fill me-2" />
          Saved to your library and tagged <strong>ai</strong>.
        </motion.div>
      </div>
    </motion.div>
  );
};

export default McpMock;
